import React from 'react';
import { Text4, Text5 } from '../../../styles';
import { printRupee } from '../../../app_methods';
import moment from 'moment';
import { Badge, Popover, Icon, Popconfirm } from 'antd';
import { TRANSFER_STATUS_TYPES, PAYMENT_METHODS } from '../../../constants';


export const getTransfersTableColumns = (methods) => [{
    title: "Created At",
    key: "created_at",
    render: (record) => <Text4>{moment(record.created_at).format("lll")}</Text4>
}, {
    title: "URN",
    key: "unique_request_number",
    width: "25%",
    render: (record) => <Text4>{record.unique_request_number}</Text4>
}, {
    title: "Beneficiary",
    key: "beneficiary_account_name",
    render: (record) =>
        <div>
            <Text4 className="d-block">{record.beneficiary_account_name}</Text4>
            {
                record.payment_mode == "UPI" ?
                    <Text5 className="d-block" secondary>{record.beneficiary_upi_handle}</Text5>
                    :
                    <Text5 className="d-block" secondary>{record.beneficiary_account_number}</Text5>
            }
        </div>
}, {
    title: "Payment Mode",
    key: "payment_mode",
    render: (record) => <Text4>{record.payment_mode}</Text4>
}, {
    title: "Transfer Amount",
    key: "amount",
    render: (record) => <Text4>{printRupee(record.amount)}</Text4>
}, {
    title: "UTR",
    key: "unique_transaction_reference",
    render: (record) =>
        <div>
            <Text4>{record.unique_transaction_reference || "---"}</Text4>
        </div>
}, {
    title: <span className="c-pointer" onClick={methods.setShowStatusInfoDrawer}><span>Status</span><Icon style={{ fontSize: 14 }} className="ml-1" type="info-circle" /></span>,
    key: "status",
    render: (record) =>
        <div>
            {
                ["failure", "rejected"].includes(record.status) ?
                    <Popover title="Reason" placement="top" trigger="hover" content={record.failure_reason || "N/A"}>
                        <Badge color={TRANSFER_STATUS_TYPES[record.status].color} text={<Text4>{TRANSFER_STATUS_TYPES[record.status].label}</Text4>} />
                        <Icon style={{ fontSize: 12 }} className="ml-1" type="info-circle" />
                    </Popover>
                    :
                    <div>
                        <Badge color={TRANSFER_STATUS_TYPES[record.status].color} text={<Text4>{TRANSFER_STATUS_TYPES[record.status].label}</Text4>} />
                    </div>
            }
        </div>
}];

export const transfersTableFilterNodes = (params = {}, current_user) => {
    let virtual_accounts = params.virtual_accounts;
    let merchant_payment_modes = []
    PAYMENT_METHODS.forEach(payment_method => {
       if (params.merchant_payment_modes.includes(payment_method.value)) {
           merchant_payment_modes.push(payment_method.value)
       }
    });

    let nodes = [{
        label: "Created At",
        field: "created_at",
        placeholder: "Select Transfer Date",
        inputType: "date_range",
        defaultValue: [moment().subtract(3, 'days'), moment()],
        preventClear: true
    }, {
            label: "Account No.",
            field: "virtual_account",
            placeholder: "Select Virtual Account",
            inputType: "select",
            width: 200,
            disabled: (virtual_accounts || []).length < 1,
            defaultValue: undefined,
            options: (virtual_accounts || []).map((account, idx) => {
                return {
                    key: idx,
                    value: account.id,
                    label: account.label
                }
            })
        }, {
        label: "URN",
        field: "merchant_request_number",
        placeholder: "Enter URN",
        inputType: "text",
        defaultValue: ""
    }, {
        label: "Beneficiary",
        field: "beneficiary_account_name",
        placeholder: "Enter Beneficiary Name",
        inputType: "text",
        defaultValue: ""
    }, {
        label: "Payment Mode",
        field: "payment_mode",
        placeholder: "Select Payment Mode",
        inputType: "select",
        defaultValue: undefined,
        options: merchant_payment_modes.map((mode, index) => {
            return Object.create({
                key: index + 1,
                value: mode,
                label: mode    
            })
        })
    }, {
        label: "Status",
        field: "status",
        placeholder: "Select Status",
        inputType: "select",
        defaultValue: undefined,
        options: Object.keys(TRANSFER_STATUS_TYPES).map((type, index) => {
            let object = {};
            object.key = index;
            object.value = type;
            object.label = <Badge color={TRANSFER_STATUS_TYPES[type].color} text={<Text4>{TRANSFER_STATUS_TYPES[type].label}</Text4>} />;
            return object;
        })
    }, {
        label: "UTR",
        field: "unique_transaction_reference",
        placeholder: "Enter UTR",
        inputType: "text",
        defaultValue: ""
    }, {
        label: "Batch ID",
        field: "batch_id",
        placeholder: "Enter Batch ID",
        inputType: "text",
        defaultValue: params.batch_id || ""
    }];
   if (current_user.is_reseller && current_user.esda){
        nodes.unshift({
            label: "Merchant",
            field: "submerchant_id",
            placeholder: "Merchant ID",
            width: 200,
            inputType: "select",
            showSearch: true,
            defaultValue: undefined,
            dependantFields: ['virtual_account'],
            options: current_user.submerchants ? current_user.submerchants.map((sub_merchant, index) => {
                let object = {};
                object.key = index;
                object.value = sub_merchant.id;
                object.label = sub_merchant.name+" ("+sub_merchant.email+")"
                return object;
            }): []

        })
    }
    return nodes
}
